export enum SoundMarkerType {
  File = 'File',
  Position = 'Position'
}